import EntitiesSelectionModal from './EntitiesSelectionModal';

export default EntitiesSelectionModal;
